/**
* 小程序首页图片
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>首页图片管理</el-breadcrumb-item>
    </el-breadcrumb>
    <br> <br>
    <!-- 新增编辑界面 -->
      <el-form label-width="10px" ref="editForm" :model="editForm">
        <el-form-item>
          <el-upload
            class="upload-demo"
            action="/api/business/image/uploadImage"
            accept="image/jpeg,image/jpg,image/png"
            multiple
            :on-remove="handleRemove"
            :http-request="UploadFile"
            :file-list="editForm.fileList"
            list-type="picture-card">
            <el-button size="small" type="primary">上传图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpeg/jpg/png文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
  // 导入请求方法
  import {
    imageList,
    imageSave,
    imageDel
  } from '../../api/imageMg'
  import {roomDelete} from "../../api/roomMg";
  export default {
    data() {
      // 请求数据参数
      return {
        loading: false, //是显示加载
        title: '添加首页图片',
        editFormVisible: false, //控制编辑页面显示与隐藏
        // 编辑与添加
        editForm: {
          id: '',
          type:'3',
          fileList: [],
          imgUrl:'',
          token: localStorage.getItem('logintoken')
        },
        fileList: []
      }
    },
    // 注册组件
    components: {
    },
    computed:{
      //计算属性
    },
    /**
     * 数据发生改变
     */
    watch: {},
    /**
     * 创建完毕,初始化数据
     */
    created() {
      this.getdata()
    },
    methods: {
      getdata() {
        //获取客房列表
        imageList().then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            if (res.result != null && res.result.length > 0){
              res.result.forEach(item=>{
                let obj = new Object();
                obj.url = "https://hotel.leikl.com/images/"+item.imgUrl;
                this.editForm.fileList.push(obj);
              })
            }
          }
        })
      },
      //搜索事件
      search() {
        this.getdata()
      },
      UploadFile(param) {
        var data = new FormData();
        data.append("file", param.file);
        var config = {
          headers: {'Content-Type': 'multipart/form-data', token: localStorage.getItem('logintoken')}
        }
        this.$axios.post(param.action, data, config).then((res) => {
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            //数组只赋值字符串url，无法自动传教uid，删除时无法处理，此处传对象
            this.editForm.imgUrl=res.data.result;
            this.editForm.type="3";
            // 新增图片信息
            imageSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.success) {
                  this.getdata()
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.$refs['editForm'].resetFields();
                  this.editForm.fileList=[];
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }
        })
      },
      handleRemove(file) {
        let index= this.editForm.fileList.findIndex(fileItem =>{
          return fileItem.uid === file.uid;
        });
        this.editForm.fileList.splice(index,1);
        let url = file.url.replace("https://hotel.leikl.com/images/","");
        imageDel(url)
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '数据已删除!'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('数据删除失败，请稍后再试！')
          })
      }
    }
  }
</script>

<style scoped>
  .search {
    margin-top: 20px;
  }
  .bedType-class /deep/ .el-form-item__label{
    width: 61px;
  }
</style>



// WEBPACK FOOTER //
// src/views/hotel/Images.vue